import type { Layer, SceneProfileId, VisualPurpose } from '../types';

const ALL_PURPOSES: readonly VisualPurpose[] = [
  'administrative-overlay',
  'navigation-environment',
  'context-fabric',
  'engineering-detail',
  'media-overlay',
];

export function normalizeSceneProfile(value: unknown): SceneProfileId {
  if (value === 'oil-gas' || value === 'smart-city' || value === 'renewables' || value === 'hybrid') {
    return value;
  }
  return 'hybrid';
}

export function readLayerVisualPurpose(layer: Pick<Layer, 'visualPurpose' | 'style'>): VisualPurpose | null {
  if (layer.visualPurpose) return layer.visualPurpose;
  const value = layer.style?.visualPurpose;
  return isVisualPurpose(value) ? value : null;
}

export function allowedVisualPurposes(
  profile: SceneProfileId,
  activeLoR: number,
): readonly VisualPurpose[] {
  if (profile === 'hybrid') return ALL_PURPOSES;
  if (profile === 'smart-city') {
    return activeLoR <= 2
      ? ['administrative-overlay', 'navigation-environment', 'context-fabric', 'media-overlay']
      : ALL_PURPOSES;
  }
  if (profile === 'renewables') {
    return activeLoR <= 2
      ? ['administrative-overlay', 'navigation-environment', 'context-fabric']
      : ALL_PURPOSES;
  }
  return activeLoR <= 2
    ? ['administrative-overlay', 'navigation-environment', 'media-overlay']
    : ALL_PURPOSES;
}

export function isLayerAllowedForSceneProfile(
  layer: Layer,
  profile: SceneProfileId,
  activeLoR: number,
): boolean {
  const purpose = readLayerVisualPurpose(layer);
  if (!purpose) return true;
  return allowedVisualPurposes(profile, activeLoR).includes(purpose);
}

function isVisualPurpose(value: unknown): value is VisualPurpose {
  return (
    value === 'administrative-overlay'
    || value === 'navigation-environment'
    || value === 'context-fabric'
    || value === 'engineering-detail'
    || value === 'media-overlay'
  );
}
